import gql from 'graphql-tag'

export default gql`
  mutation handlePaymentSuccess($input: HandlePaymentSuccessInput!) {
    handlePaymentSuccess(input: $input) {
      success
      message
    }
  }
`
